import gql from 'graphql-tag';

import { FRAGMENT_BLOG_POST_BUILDER_DRAFT } from 'src/graphql/blog/schema';
import { BRIEF_FRAGMENT } from 'src/graphql/brief';
import { executeGqlQuery } from 'src/graphql/client';
import { CUSTOMER_FRAGMENT } from 'src/graphql/customer';
import { FRAGMENT_LONG_FORM_BUILDER_DRAFT } from 'src/graphql/longFormBuilder/schema';
import { getSingleProp } from 'src/lib/graphql';

import { PROJECT_FRAGMENT } from './schema';

const QUERY = gql`
  query Project($projectId: Int!) {
    project(id: $projectId) {
      ...Project

      customer {
        ...Customer
      }

      brief {
        ...Brief
      }

      longFormBuilderDrafts {
        ...LongFormBuilderDraft
      }

      blogPostBuilderDrafts {
        ...BlogPostBuilderDraft
      }
    }
  }
  ${PROJECT_FRAGMENT}
  ${BRIEF_FRAGMENT}
  ${CUSTOMER_FRAGMENT}
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
  ${FRAGMENT_BLOG_POST_BUILDER_DRAFT}
`;

export const queryProject = (projectId, options) =>
  executeGqlQuery({
    query: QUERY,
    variables: {
      projectId,
    },
    options: {
      abortSignal: options?.abortSignal,
    },
  }).then(({ data }) => getSingleProp(data));
